module.exports = __webpack_public_path__ + "img/sign_up_banner.4f722373.jpg";